"use client";
import Image from "next/image";
import { Heading } from "@/components/ui/typography";

const plans = [
  {
    title: "eCommerce brands selling internationally",
    icon: "/deadline-icon-1.svg",
  },
  {
    title: "SaaS companies with global users",
    icon: "/deadline-icon-2.svg",
  },
  {
    title: "Digital agencies serving overseas clients",
    icon: "/deadline-icon-3.svg",
  },
  {
    title: "Consultants working remotely",
    icon: "/deadline-icon-1.svg",
  },
  {
    title: "Coaches with international clients",
    icon: "/deadline-icon-2.svg",
  },
  {
    title: "Content businesses monetising globally",
    icon: "/deadline-icon-3.svg",
  },
];

export default function IncludedPlans({ heading = "What Happens If You Miss a Deadline?" }: { heading?: string } = {}) {
  return (
    <section className="bg-black py-[60px] flex flex-col items-center px-4">

      {/* HEADING */}
      <div className="flex flex-col items-center gap-6 max-w-[736px] text-center">
        <Heading as="h2" variant="sectionCentered">
          {heading}
        </Heading>
        <p className="text-white/60 text-[16px] md:text-[18px] leading-[160%] font-medium max-w-[716px]">
          In Hong Kong, non-compliance isn&apos;t just an inconvenience, it&apos;s a
          significant financial and legal risk.
        </p>
      </div>

      {/* GRID */}
      <div className="mt-[60px] w-full max-w-[892px] grid grid-cols-1 md:grid-cols-3 gap-x-[32px] gap-y-[63px]">
        {plans.map((item, index) => (
          <Card key={index} title={item.title} icon={item.icon} />
        ))}
      </div>
    </section>
  );
}

/* CARD COMPONENT */
function Card({ title, icon }: { title: string; icon: string }) {
  return (
    <div className="relative bg-[#0f1218] border border-white/10 rounded-[12px] pt-[60px] pb-6 px-6 flex flex-col items-center text-center h-[143px]">

      {/* FLOATING ICON */}
      <div className="absolute -top-[39px] left-1/2 -translate-x-1/2 w-[78px] h-[78px] bg-black border-2 border-white/10 rounded-full flex items-center justify-center">
        <Image src={icon} alt="icon" width={25} height={25} className="[filter:brightness(0)_invert(1)]" />
      </div>

      {/* TEXT */}
      <h3 className="text-white text-[18px] md:text-[20px] leading-[110%] font-medium">
        {title}
      </h3>
    </div>
  );
}